// extracted by mini-css-extract-plugin
export default {"row":"_8p6ODvIzqrRqKoxb0SV","column":"QGYOFXsVE2r9ATs3Hc2h"};